import { Column, Text } from "@hightouch/htui";
import { Link } from "src/router";
import { useNavigate } from "src/router";
import { AuthLayout } from "src/components/auth/auth-layout";
import {
  MicrosoftButton,
  EmailButton,
  StyledButton,
} from "src/components/auth/buttons";
import { BuildingIcon } from "src/components/auth/logos";
import GoogleIdentityButton from "src/components/auth/google-identity-button";
import { Terms } from "src/components/auth/terms";
import { useAuthState } from "src/components/auth/use-auth-state";
import { PartnerConnectHeader } from "src/pages/partner-connect";
import { PageSpinner } from "src/components/loading";
import { AuthCard } from "src/components/auth/auth-card";
import { buildReturnToUrl } from "src/utils/auth-redirect";

export const Login = () => {
  const navigate = useNavigate();
  const {
    returnTo,
    isMcpAuthFlow,
    partnerConnectionUUID,
    partnerInformation,
    microsoftAuthUrl,
    handleSuccessfulOauth,
    isHandlingSuccessfulOauth,
  } = useAuthState();

  if (isHandlingSuccessfulOauth) {
    return <PageSpinner />;
  }

  return (
    <AuthLayout metaTitle="Log in">
      <AuthCard
        heading={
          partnerInformation
            ? `Connect Hightouch to ${partnerInformation.partnerName}`
            : "Log in to Hightouch"
        }
      >
        {partnerInformation && (
          <PartnerConnectHeader partnerInformation={partnerInformation} />
        )}

        <Column gap={4}>
          <GoogleIdentityButton
            action="Log in"
            onSuccess={handleSuccessfulOauth}
            partnerConnectionUUID={partnerConnectionUUID}
          />
          <MicrosoftButton
            action="Log in"
            onClick={() => {
              window.location.href = microsoftAuthUrl;
            }}
          />
          <EmailButton
            action="Log in"
            onClick={() => {
              navigate(
                returnTo
                  ? buildReturnToUrl("/login/email", returnTo)
                  : "/login/email",
              );
            }}
          />
          <StyledButton
            icon={<BuildingIcon />}
            onClick={() => {
              navigate(returnTo ? buildReturnToUrl("/sso", returnTo) : "/sso");
            }}
          >
            Log in with SSO
          </StyledButton>
        </Column>
        <Column gap={2}>
          {isMcpAuthFlow ? (
            <Text fontWeight="medium">
              New accounts can continue with the sign-in options above.
            </Text>
          ) : (
            <Text fontWeight="medium">
              Don't have an account? <Link href="/signup">Sign up</Link>
            </Text>
          )}
          <Terms />
        </Column>
      </AuthCard>
    </AuthLayout>
  );
};

export default Login;
